








import { Vue, Component, Prop } from "vue-property-decorator";
import i18n from "@/i18n";

@Component
export default class UDelegatedObjectMsg extends Vue {
  // Props
  @Prop({ default: () => i18n.t("_.resource") })
  public objectType!: string;
}
